import apiClient from './api';

/** Store mode (22 Oct 2026): public store pages + branding edits. */

function detail(error, fallback) {
  const d = error.response?.data?.detail;
  return typeof d === 'string' ? d : fallback;
}

function statusOf(error) {
  return error.response?.status || 0;
}

export class StorePublicService {
  /** { success, store } | { success:false, notFound, unavailable } */
  static async getStore(handle) {
    try {
      const response = await apiClient.get(`/stores/${encodeURIComponent(handle)}`);
      return { success: true, store: response.data };
    } catch (error) {
      const code = statusOf(error);
      return { success: false, notFound: code === 404, unavailable: code === 503, error: detail(error, 'Failed to load store') };
    }
  }

  static async getProducts(handle, { skip = 0, limit = 24, q = '', sortBy, sortOrder, listingType } = {}) {
    try {
      const params = { skip, limit };
      if (listingType) params.listing_type = listingType;
      if (q && q.trim()) params.q = q.trim();
      if (sortBy) params.sort_by = sortBy;
      if (sortOrder) params.sort_order = sortOrder;
      const response = await apiClient.get(`/stores/${encodeURIComponent(handle)}/products`, { params });
      return { success: true, ...response.data };
    } catch (error) {
      const code = statusOf(error);
      return { success: false, notFound: code === 404, unavailable: code === 503, error: detail(error, 'Failed to load products') };
    }
  }

  /** Same result shape as ProductService.getProduct. */
  static async getProduct(handle, slug) {
    try {
      const response = await apiClient.get(
        `/stores/${encodeURIComponent(handle)}/products/${encodeURIComponent(slug)}`,
        { headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' } },
      );
      return { success: true, product: response.data };
    } catch (error) {
      return { success: false, unavailable: statusOf(error) === 503, error: detail(error, 'Failed to fetch product') };
    }
  }
}

async function upload(url, file) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return { success: true, url: response.data?.url };
  } catch (error) {
    return { success: false, error: detail(error, 'Failed to upload image') };
  }
}

export function uploadMyStoreImage(file) {
  return upload('/vendor/store/images', file);
}

export function uploadAdminStoreImage(storeId, file) {
  return upload(`/admin/stores/${storeId}/images`, file);
}

export async function updateAdminStoreBranding(storeId, payload) {
  try {
    const response = await apiClient.put(`/admin/stores/${storeId}/branding`, payload);
    return { success: true, branding: response.data };
  } catch (error) {
    return { success: false, error: detail(error, 'Failed to save branding') };
  }
}
